<mat-dialog-content>
    <section class="vacation-edit-dialog-wrapper">
        <h2 class="cmn-popup-title"> Edit Vacation</h2>
        <button class="cmn-close" mat-dialog-close></button>
        <form [formGroup]="vacationEditForm">
            <div class="vacation-form-wrapper">
              <div class="form-wrapper full-width-form">
                <label class="checkbox-wrapper">
                  <input type="checkbox" formControlName="isTicketEligible" />Is Ticket Eligible
                  <span class="checkmark"></span>
                </label>
              </div>
                <div class="form-wrapper">
                    <label for="">From Date<span class="red">*</span></label>
                    <mat-form-field>
                        <input matInput [matDatepicker]="pickerFrom" formControlName="startDate" placeholder="Choose date"/>
                        <mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
                        <mat-datepicker #pickerFrom></mat-datepicker>
                    </mat-form-field>
                    <div
                    *ngIf="
                      vacationEditForm.get('startDate')!.invalid &&
                      vacationEditForm.get('startDate')!.touched
                    "
                    class="error"
                  >
                    From date is required.
                  </div>
                </div>
                <div class="form-wrapper">
                  <label for="">Duration <span class="red">*</span></label>
                  <mat-form-field>
                    <mat-select placeholder="Select duration" formControlName="duration">
                      <mat-option value="7">7 days</mat-option>
                      <mat-option value="14">14 days</mat-option>
                      <mat-option value="21">21 days</mat-option>
                      <mat-option value="Custom">Custom</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div
                  *ngIf="
                  vacationEditForm.get('duration')!.invalid &&
                  vacationEditForm.get('duration')!.touched
                  "
                  class="error"
                >
                Duration is required.
                </div>
                </div>
                <div class="form-wrapper">
                    <label for="">To Date<span class="red">*</span></label>
                    <mat-form-field>
                        <input matInput [matDatepicker]="pickerTo" formControlName="endDate" placeholder="Choose date"/>
                        <mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
                        <mat-datepicker #pickerTo></mat-datepicker>
                    </mat-form-field>
                    <div
                    *ngIf="
                      vacationEditForm.get('endDate')!.invalid &&
                      vacationEditForm.get('endDate')!.touched
                    "
                    class="error"
                  >
                    To date is required.
                  </div>
                </div>
                <div class="form-wrapper">
                  <label for="">Last Working Date<span class="red">*</span></label>
                  <mat-form-field>
                    <input matInput [matDatepicker]="pickerLast" [matDatepickerFilter]="dateFilter"
                      formControlName="lastWorkingDate" placeholder="Choose date" />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerLast"></mat-datepicker-toggle>
                    <mat-datepicker #pickerLast></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="form-wrapper">
                  <label for="">Due Back Date<span class="red">*</span></label>
                  <mat-form-field>
                    <input matInput [matDatepicker]="pickerBack" [matDatepickerFilter]="dateFilter" formControlName="dueBackDate"
                      placeholder="Choose date" />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerBack"></mat-datepicker-toggle>
                    <mat-datepicker #pickerBack></mat-datepicker>
                  </mat-form-field>
                </div>
                <div class="form-wrapper">
                  <label for="">Date Of Travel<span class="red">*</span></label>
                  <mat-form-field>
                    <input matInput [matDatepicker]="pickerTravel" [matDatepickerFilter]="dateFilter" formControlName="travelDate"
                      placeholder="Choose date" />
                    <mat-datepicker-toggle matIconSuffix [for]="pickerTravel"></mat-datepicker-toggle>
                    <mat-datepicker #pickerTravel></mat-datepicker>
                  </mat-form-field>
                  <div *ngIf="
                        vacationEditForm.get('travelDate')!.invalid &&
                        vacationEditForm.get('travelDate')!.touched
                      " class="error">
                    Travel date is required.
                  </div>
                </div>
                <div class="form-wrapper">
                  <label for="">Travel From<span class="red">*</span></label>
                  <mat-form-field>
                    <input matInput placeholder="From" formControlName="travelFrom">
                  </mat-form-field>
                  <div *ngIf="
                        vacationEditForm.get('travelFrom')!.invalid &&
                        vacationEditForm.get('travelFrom')!.touched
                      " class="error">
                    Travel from is required.
                  </div>
                </div>
                <div class="form-wrapper">
                  <label for="">Travel To<span class="red">*</span></label>
                  <mat-form-field>
                    <input matInput placeholder="To" formControlName="travelTo">
                  </mat-form-field>
                  <div *ngIf="
                        vacationEditForm.get('travelTo')!.invalid &&
                        vacationEditForm.get('travelTo')!.touched
                      " class="error">
                    Travel to is required.
                  </div>
                </div>
                <div class="form-wrapper">
                    <label for="">Notes</label>
                    <mat-form-field>
                        <textarea matInput placeholder="Type something.."></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="btn-wrapper">
                <button class="cmn-popup-btn" (click)="onEdit()">
                  Submit 
                </button>
              </div>
        </form>
    </section>
</mat-dialog-content>